import { useMemo } from 'react'
import { ISortSelectOption } from 'src/components/filter/types/filter.types'

import { useAllAccounts } from './use-all-accounts.hook'
import { defaultSelect } from 'src/constants'

const useAccountsSelectionOptions = () => {
  const { data: accounts } = useAllAccounts()

  const accountsSelectValues = useMemo(() => {
    const selectionValues: ISortSelectOption[] = accounts
      ? accounts?.data.map(({ id, account_holder }) => ({
          label: account_holder,
          value: id,
        }))
      : []

    selectionValues.unshift(defaultSelect)

    return selectionValues
  }, [accounts])

  return {
    selectName: 'accounts-filter-title.v',
    queryParamName: 'account',
    items: accountsSelectValues,
  }
}

export { useAccountsSelectionOptions }
